<template>
    <div class="modal-warning">
        <slot />
    </div>
</template>

<script></script>

<style lang="stylus">
.modal-warning {
    font-size: .85em;
}
</style>
